import { render, staticRenderFns } from "./CobrancaListagem.vue?vue&type=template&id=0f613cda&scoped=true"
import script from "./CobrancaListagem.vue?vue&type=script&lang=js"
export * from "./CobrancaListagem.vue?vue&type=script&lang=js"
import style0 from "./CobrancaListagem.vue?vue&type=style&index=0&id=0f613cda&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f613cda",
  null
  
)

export default component.exports